// src/sections/Section6.jsx
import React, { useState, useEffect } from "react";
import InfoCard from "../components/InfoCard";

const Section6 = ({ contenuti }) => {

  const items = (Array.isArray(contenuti)
    ? contenuti
    : Object.values(contenuti)
  ).sort((a, b) => Number(a.ordine) - Number(b.ordine));

  const header = items.find(it => Number(it.ordine) === 0);
  const cards  = items.filter(it => Number(it.ordine) > 0);

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 992);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  if (!header) return null;

  const lgCols = cards.length <= 4 ? 3 : 4;

  return (
    <>
      {/* --- HEADER --- */}
      <div
        className="d-flex flex-column align-items-center position-relative"
        style={{
          padding: "76px 16px",
          gap: "16px",
          backgroundImage: 'var(--bg-dark-theme)',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
          <div className="position-absolute w-100 head-onda reverse">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1440 50"
                preserveAspectRatio="none"
                className="w-100"
              >
                <path
                  fill="#fff" // Colore di Bootstrap bg-light
                  d="M0,50L80,45C160,40,320,30,480,25C640,20,800,20,960,25C1120,30,1280,40,1360,45L1440,50L1440,50L1360,50C1280,50,1120,50,960,50C800,50,640,50,480,50C320,50,160,50,80,50L0,50Z"
                ></path>
              </svg>
            </div>

        <div className="container title-section text-center">
          <span
            className={`white-text ${
              isMobile
                ? "d-inline-block d-lg-none title-section-mobile"
                : "d-none d-lg-inline-block title-section"
            }`}
          >
            {header.titolo_1}
          </span>{" "}
          <span
            className={`light-green-text ${
              isMobile
                ? "d-inline-block d-lg-none title-section-mobile"
                : "d-none d-lg-inline-block title-section"
            }`}
          >
            {header.titolo_2}
          </span>

          {header.descrizione_it && (
            <p
              className="custom-text white-text my-5 text-start"
              dangerouslySetInnerHTML={{ __html: header.descrizione_it }}
            />
          )}
        </div>
                <div className="container">
          <div className="row">
            {cards.map(card => (
              // 2) applico la classe calcolata
              <div
                key={card.ID}
                className={`col-12 col-lg-4 col-xl-${lgCols} mb-4`}
              >
                <InfoCard
                  img={null}
                  superText={card.titolo_it}
                  subtitle={card.sottotitolo_it}
                  text={
                    <span
                      dangerouslySetInnerHTML={{ __html: card.descrizione_it }}
                    />
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Section6;
